/* eslint-disable react/prop-types */
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import convertPrice from "../../services/price/convertPrice"
import Translate from "../../../../app/scripts/components/Translate"
import {
  formatPriceSelector,
  roundAmountSelector,
  currenciesSelector,
} from "../../services/currencies/selectors"
import { getCurrency } from "../../services/options/reducer"

const Price = props => {
  const {
    currencies,
    formatPrice,
    freeInsteadOfZero,
    optionsCurrency,
    formatThousandsAndDecimals,
    roundAmount,
  } = props

  const currency = props.currency || optionsCurrency

  let { className } = props

  let amountInEur
  let amountInCurrency
  if (props.alreadyConverted) {
    if (props.alreadyRounded) {
      amountInCurrency = props.children
    } else {
      amountInCurrency = roundAmount(props.children, currency)
    }
  } else {
    amountInEur = props.children
    amountInCurrency = convertPrice(amountInEur, currency, currencies)
  }

  if (amountInCurrency === 0 && freeInsteadOfZero) {
    return props.tKey ? (
      <Translate
        dynamic
        className={className}
        tKey={props.tKey}
        values={{
          price: <Translate tKey="support.passenger-details.correct-details.common.free" />,
        }}
      />
    ) : (
      <Translate
        className={className}
        options={{ process: "uppercase" }}
        tKey="support.passenger-details.correct-details.common.free"
      />
    )
  }

  let output = formatPrice(currency, amountInCurrency, formatThousandsAndDecimals)

  if (props.maxSize) {
    const roundedPrice = amountInCurrency.toFixed(0)

    output = formatPrice(currency, roundedPrice)
    if (!props.showCurrencySymbol) {
      // If still too long, remove currency symbol
      if (`${output}`.length > props.maxSize || props.hideCurrencySymbol) {
        output = roundedPrice

        if (`${output}`.length > props.maxSize) {
          // If still too long, round to thousands
          output = roundedPrice / 1000
          if (Math.round(output) !== output) {
            output = output.toFixed(1)
          }
          output = `${output}k`
        }

        if (`${output}`.length >= props.maxSize) {
          // If too big, (just as maxSize or bigger), add class to notify about that
          className += " long spTypo-caption spTypo-bold"
        }
      }
    }
  }
  className += ` length-${output.length}`
  if (props.noBreak) {
    // replace spaces with nbsp
    return props.tKey ? (
      <Translate className={className} tKey={props.tKey} values={{ price: output }} />
    ) : (
      <span className={className}>{output.replace(/ /g, "\u00a0")}</span>
    )
  }
  return props.tKey ? (
    <Translate className={className} tKey={props.tKey} values={{ price: output }} />
  ) : (
    <span className={className}>{output}</span>
  )
}

Price.defaultProps = {
  className: "",
  alreadyConverted: false,
  alreadyRounded: false,
  freeInsteadOfZero: false,
  noBreak: false,
  formatThousandsAndDecimals: true,
}

Price.propTypes = {
  hideCurrencySymbol: PropTypes.bool,
  maxSize: PropTypes.number, // max size of string in digits
  showCurrencySymbol: PropTypes.bool, // undefined = auto
  alreadyConverted: PropTypes.bool,
  alreadyRounded: PropTypes.bool,
  className: PropTypes.string,
  currency: PropTypes.string, // when not specified, taken from "global" options
  optionsCurrency: PropTypes.string, // connected
  tKey: PropTypes.string, // translation key, translation string has to contain __price__ placeholder
  // children: PropTypes.number // TODO: Enforce number, now it could be string with number inside
  freeInsteadOfZero: PropTypes.bool,
  noBreak: PropTypes.bool,
  formatThousandsAndDecimals: PropTypes.bool,
  roundAmount: PropTypes.func.isRequired,
}

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({
  optionsCurrency: getCurrency(state),
  currencies: currenciesSelector(state),
  formatPrice: formatPriceSelector(state),
  roundAmount: roundAmountSelector(state),
}))(Price)
